import { declaredBaudRate } from './firmwareSketch';

/**
 * Las placas a las que esta pestaña les cargó código con el firmware embebido,
 * por nombre de puerto.
 *
 * Es lo que permite no pedir que se instale el firmware en una placa a la que se
 * le acaba de grabar: si no contesta el ping es porque el loop del usuario la
 * tiene ocupada, o porque habla a otra velocidad, no porque le falte. Y el modal
 * de instalación graba el sketch vacío encima del programa del usuario.
 *
 * Vive en memoria y nada más: lo que importa es lo que se grabó en esta sesión.
 */
const uploads = new Map();

export const recordFirmwareUpload = (portName, code) => {
  if (!portName) return;
  uploads.set(portName, { baudRate: declaredBaudRate(code) });
};

export const firmwareUploadFor = (portName) => uploads.get(portName) || null;

// Para los tests, que necesitan empezar sin nada de la prueba anterior.
export const forgetFirmwareUploads = () => uploads.clear();
